<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <!-- 轮播图片容器 -->
      <div class="hero-background">
        <div class="hero-slides">
          <div 
            v-for="slide in heroSlides" 
            :key="slide.id"
            class="hero-slide"
            :class="{ 'active': currentSlide === heroSlides.indexOf(slide) }"
          >
            <img :src="slide.image" :alt="slide.title1" class="hero-bg-image">
            <div class="hero-overlay"></div>
          </div>
        </div>
      </div>
          
      <!-- 轮播内容 -->
      <div class="hero-content">
        <h1 class="hero-title">{{ heroSlides[currentSlide].title1 }}</h1>
        <h1 class="hero-title">{{ heroSlides[currentSlide].title2 }}</h1>
        <div class="hero-subtitle-container">
          <img :src="Images.home.left" alt="left bar" class="hero-subtitle-line">
          <span class="hero-subtitle">{{ heroSlides[currentSlide].subtitle }}</span>
          <img :src="Images.home.right" alt="right bar" class="hero-subtitle-line">
        </div>
        <button class="hero-button">加入我们</button>
      </div>
      
      <!-- 轮播指示器 -->
      <div class="hero-indicators">
        <div 
          v-for="(slide, index) in heroSlides" 
          :key="slide.id"
          class="hero-indicator"
          :class="{ 'active': currentSlide === index }"
          @click="goToSlide(index)"
        ></div>
      </div>
    </section>
    <!-- About Section -->
    <section id="about" class="about">
      <div class="container">
        <div class="about-content">
          <div class="about-text">
          <h2 class="section-title-complay">关于竟加技术</h2>
          <br/>
          <br/>
            <p class="complay-text">深圳市竟加技术有限公司，是专注于AI软硬件全栈解决方案的创新型科技公司，提供硬件设计、软件开发、APP开发及AI模型赋能等全方位服务。</p>
          <br/>
            <p class="complay-text">公司与火山引擎官方深度合作，基于杰瑞芯片平台打造端侧AI大模型解决方案，已成功赋能蓝牙耳机、智能眼镜等消费电子产品，实现AI翻译、录音、对话等功能。目前合作客户包括联想、杰理、纽曼等头部品牌，相关产品均已批量上市。</p>
          </div>
          <div class="about-image">
            <img :src="Images.home.meeting" alt="Team Meeting">
          </div>
        </div>
      </div>
    </section>
    
    <!-- Services Section -->
    <section id="services" class="services">
      <div class="container">
        <h2 class="section-title">核心业务</h2>
        <p class="section-subtitle">核心业务：工控 / 消费 / 电源电子领域PCBA一站式服务可按需提供成品加工及结构设计服务。</p>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">
              <img :src="Images.home.business_1" alt="产品设计">
            </div>
            <h3 class="service-title">产品设计</h3>
            <p class="service-description">提供工控 / 消费 / 电源电子领域专业化产品设计，通盘功能架构、外观形态、结构适配设计，助力产品从概念高效落地。</p>
            <a href="#" class="service-more">了解更多 <img :src="Images.home.to_right" alt="箭头"></a>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img :src="Images.home.business_2" alt="方案开发">
            </div>
            <h3 class="service-title">方案开发</h3>
            <p class="service-description">提供全流程方案开发，输出需求拆解、技术选型、落地验证一体化方案，适配加工与应用场景。</p>
            <div class="service-more">了解更多 <img :src="Images.home.to_right" alt="箭头"></div>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img :src="Images.home.business_3" alt="产品加工">
            </div>
            <h3 class="service-title">产品加工</h3>
            <p class="service-description">提供PCBA一站式加工生产，覆盖贴片、焊接、组装等全工序，可按需提供成品加工及结构配套服务，保障品质与效率。</p>
            <div class="service-more">了解更多 <img :src="Images.home.to_right" alt="箭头"></div>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img :src="Images.home.business_4" alt="互联网">
            </div>
            <h3 class="service-title">互联网</h3>
            <p class="service-description">提供电子设备联网适配、智能互联开发、远程管理集成服务，助力产品数字化、智能化转型，提升市场竞争力。</p>
            <div class="service-more">了解更多 <img :src="Images.home.to_right" alt="箭头"></div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Products Section -->
    <section id="products" class="products">
      <div class="container">
        <h2 class="section-title">最新产品</h2>
        <p class="section-subtitle">AI软硬件全栈解决方案，为消费电子企业注入 AI 核心竞争力，解锁数字化创新新体验</p>
        <div class="products-grid">
          <div class="product-card">
            <div class="product-image">
              <img :src="Images.home.product_1" alt="智能机器人">
            </div>
            <h3 class="product-title">桌面机器人</h3>
            <p class="product-description">通过AI技术，桌面机器人能够与用户进行互动对话、讲故事、学习辅导等，成为孩子们的智能小伙伴。</p>
            <router-link to="/productDetail" class="product-more">了解更多</router-link>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img :src="Images.home.product_2" alt="智能控制系统">
            </div>
            <h3 class="product-title">彩屏耳机仓</h3>
            <p class="product-description">支持高品质音频体验，还具备独特的彩屏充电仓设计，方便用户随时了解耳机电量和其他信息。</p>
            <router-link to="/productDetail" class="product-more">了解更多</router-link>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img :src="Images.home.product_3" alt="数据分析平台">
            </div>
            <h3 class="product-title">彩屏音箱</h3>
            <p class="product-description">集成了人工智能助手，可以帮助用户进行语音控制、音乐播放、日程提醒等功能，让家居生活更加智能便捷。</p>
            <div class="product-more">了解更多</div>
          </div>
        </div>
        <div class="products-more">
          <router-link to="/productDetail" class="products-button">查看全部产品</router-link>
        </div>
      </div>
    </section>
    
    <!-- News Section -->
    <section id="news" class="news">
      <div class="container">
        <h2 class="section-title">最新动态</h2>
        <p class="section-subtitle">了解竟加技术的最新动态、行业洞察和技术趋势</p>
        <div class="news-content">
          <div class="news-image">
            <img :src="Images.home.ai_robot" alt="AI机器人">
          </div>
          <div class="news-right">
            <div class="news-tabs">
              <button class="news-tab active">最新动态</button>
              <button class="news-tab">典型案例</button>
              <button class="news-tab">通知公告</button>
              <a href="#" class="news-more">More</a>
            </div>
            <div class="news-list">
              <div class="news-item">
                <div class="news-item-content">
                  <span class="news-item-bullet">•</span>
                  <a href="#" class="news-item-title">智慧城市与数字孪生怎么"生"？</a>
                  <span class="news-item-date">2025-11-19</span>
                </div>
              </div>
              <div class="news-item">
                <div class="news-item-content">
                  <span class="news-item-bullet">•</span>
                  <a href="#" class="news-item-title">成为云计算领域最火概念之后 国内"云原生" ...</a>
                  <span class="news-item-date">2025-11-19</span>
                </div>
              </div>
              <div class="news-item">
                <div class="news-item-content">
                  <span class="news-item-bullet">•</span>
                  <a href="#" class="news-item-title">我国北斗系统加速与新技术融合发展</a>
                  <span class="news-item-date">2025-11-19</span>
                </div>
              </div>
              <div class="news-item">
                <div class="news-item-content">
                  <span class="news-item-bullet">•</span>
                  <a href="#" class="news-item-title">荣耀成立智能机器公司 注册资本1亿元</a>
                  <span class="news-item-date">2025-11-19</span>
                </div>
              </div>
              <div class="news-item">
                <div class="news-item-content">
                  <span class="news-item-bullet">•</span>
                  <a href="#" class="news-item-title">智慧城市与数字孪生怎么"生"？</a>
                  <span class="news-item-date">2025-11-19</span>
                </div>
              </div>
              <div class="news-item">
                <div class="news-item-content">
                  <span class="news-item-bullet">•</span>
                  <a href="#" class="news-item-title">智慧城市与数字孪生怎么"生"？</a>
                  <span class="news-item-date">2025-11-19</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Contact Section -->
    <section id="contact" class="contact">
      <div class="container">
        <h2 class="contact-title">联系我们</h2>
        <p class="contact-subtitle">如果您对我们的产品和服务有任何疑问，或者想了解更多信息，请随时与我们联系</p>
        <div class="contact-button-container">
          <button class="contact-button">联系我们</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';
import store from '@/utils/store';

export default {
  name: 'HomeView',
  data() {
    return {
      Images,
      // 轮播图片数据
      heroSlides: [
        {
          id: 1,
          image: Images.home.background_1,
          title1: '科技新时代',
          title2: '电子新世纪',
          subtitle: 'BELIEVE IN YOURSELF'
        },
        {
          id: 2,
          image: Images.home.background_2,
          title1: '创新驱动发展',
          title2: '科技引领未来',
          subtitle: 'INNOVATION LEADS THE FUTURE'
        },
        {
          id: 3,
          image: Images.home.background_3,
          title1: 'AI赋能生活',
          title2: '智能改变世界',
          subtitle: 'AI EMPOWERS LIFE'
        },
        {
          id: 4,
          image: Images.home.background_4,
          title1: '品质铸就品牌',
          title2: '服务赢得未来',
          subtitle: 'QUALITY AND SERVICE'
        }
      ],
      currentSlide: 0,
      slideInterval: null
    }
  },
  created() {
    console.log('Home组件创建，准备检查微信登录回调...');
    // 组件创建时就检查微信登录回调
    this.checkWechatLoginCallback()
  },
  mounted() {
    console.log('Home组件挂载，再次检查微信登录回调...');
    this.startAutoSlide()
    // 再次检查微信登录回调，确保能捕获到URL参数
    this.checkWechatLoginCallback()
  },
  watch: {
    // 监听路由变化，确保在路由切换时也能检查微信登录回调
    $route() {
      console.log('路由变化，检查微信登录回调...');
      this.checkWechatLoginCallback()
    }
  },
  beforeUnmount() {
    this.stopAutoSlide()
  },
  methods: {
    // 检查微信扫码登录回调
    checkWechatLoginCallback() {
      console.log('开始检查微信扫码登录回调...');
      
      // 获取完整的URL
      const url = window.location.href;
      console.log('当前URL:', url);
      
      // 尝试多种方式提取参数
      let phone = null;
      let avatar = null;
      
      // 方式1：使用正则表达式提取参数（适用于所有格式的URL）
      const phoneMatch = url.match(/phone=([^&]+)/);
      const avatarMatch = url.match(/(?:avatar|vatar)=([^&]+)/);
      
      if (phoneMatch) {
        phone = decodeURIComponent(phoneMatch[1]);
        console.log('通过正则表达式提取到phone:', phone);
      }
      
      if (avatarMatch) {
        avatar = decodeURIComponent(avatarMatch[1]);
        console.log('通过正则表达式提取到avatar:', avatar);
      }
      
      // 方式2：尝试使用URLSearchParams（适用于标准格式的URL）
      if (!phone) {
        try {
          const searchParams = new URLSearchParams(window.location.search);
          phone = searchParams.get('phone');
          avatar = searchParams.get('avatar');
          console.log('通过URLSearchParams提取到phone:', phone);
          console.log('通过URLSearchParams提取到avatar:', avatar);
        } catch (error) {
          console.log('使用URLSearchParams提取参数失败:', error);
        }
      }
      
      // 方式3：如果URL中包含/home&，直接提取参数
      if (!phone && url.includes('/home&')) {
        try {
          // 提取/home&后面的参数部分
          const paramsPart = url.split('/home&')[1];
          if (paramsPart) {
            // 构建临时URL以便使用URLSearchParams
            const tempUrl = `http://example.com/?${paramsPart}`;
            const searchParams = new URLSearchParams(new URL(tempUrl).search);
            phone = searchParams.get('phone');
            avatar = searchParams.get('avatar');
            console.log('通过处理/home&格式提取到phone:', phone);
            console.log('通过处理/home&格式提取到avatar:', avatar);
          }
        } catch (error) {
          console.log('处理/home&格式失败:', error);
        }
      }
      
      console.log('最终提取的参数 - phone:', phone, 'avatar:', avatar);
      
      if (phone) {
        // 微信登录成功，获取到用户信息
        console.log('微信登录成功，获取到用户昵称:', phone);
        console.log('微信登录成功，获取到用户头像:', avatar);
        
        // 将用户信息存储到store中
        const userInfo = {
          nickname: phone, // 这里phone实际上是用户昵称
          avatar: avatar || '',
          phone: '' // 可能需要从其他地方获取phone
        };
        
        // 直接调用setUser mutation设置用户信息
        store.mutations.setUser(userInfo);
        console.log('用户信息已存储到store中:', userInfo);
        console.log('登录状态:', store.state.isLoggedIn);
        console.log('存储的用户信息:', store.state.user);
        
        // 清除URL中的参数但不重新加载页面
        window.history.replaceState({}, document.title, '/home');
        console.log('URL参数已清除，页面保持不变');
        
        // 不需要使用$router.push('/home')，因为用户已经在home页面了
        // 而且push会导致页面重新加载，影响登录状态的设置
      } else {
        console.log('未找到有效的phone参数，不是微信登录回调');
      }
    },
    // 开始自动轮播
    startAutoSlide() {
      this.slideInterval = setInterval(() => {
        this.nextSlide()
      }, 5000) // 每5秒切换一次
    },
    // 停止自动轮播
    stopAutoSlide() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval)
      }
    },
    // 切换到下一张
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.heroSlides.length
    },
    // 切换到上一张
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.heroSlides.length) % this.heroSlides.length
    },
    // 切换到指定幻灯片
    goToSlide(index) {
      this.currentSlide = index
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero {
  position: relative;
  height: 82.5vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 80px;
  padding-top: 260px;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.hero-slides {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.hero-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.hero-slide.active {
  opacity: 1;
}

.hero-bg-image {
  width: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

/* 轮播指示器样式 */
.hero-indicators {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.hero-indicator {
  width: 12px;
  height: 12px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.hero-indicator.active {
  background-color: #ff6b00;
  width: 30px;
  border-radius: 6px;
}

.hero-content {
  text-align: left;
  color: white;
  z-index: 1;
  max-width: 1000px;
  padding: 0 0px;
  margin-left: 350px;

}

.hero-title {
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
  line-height: 1.2;
  color: #FFFFFF;
}

.hero-subtitle-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin: 15px 0 30px;
}

.hero-subtitle-line {
  width: auto;
  height: auto;
  max-height: 16px;
}

.hero-subtitle {
  font-size: 24px;
  font-weight: normal;
  letter-spacing: 2px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-button {
  background-color: white;
  color: #212121;
  border: none;
  padding: 10px 30px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 400;
}

.hero-button:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(-1px);
}

/* About Section */
.about {
  padding: 80px 0;
  background-color: #fff;
}

.about-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 60px;
  padding: 0;
}
.complay-text{
  font-family: Source Han Sans;
  font-size: 22px;
  font-weight: normal;
  line-height: 1.8;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #212121;
  margin-bottom: 20px;
}
.about-text {
  flex: 1;
  line-height: 1.8;
  color: #666;
}

.about-text p {
  margin-bottom: 20px;
}

.about-image {
  flex: 1;
  max-width: 1000px;
}

.about-image img {
  width: 100%;
  height: auto;
  border-radius: 0;
  box-shadow: none;
}
.section-title-complay{
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 36px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #212121;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.section-title-complay::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 80px;
  height: 4px;
  background-color: #ff6b00;
}
/* Services Section */
.services {
  padding: 80px 0;
  background-color: #fff;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-top: 40px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.service-card {
  padding: 25px;
  background-color: white;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #f0f0f0;
  transition: none;
}

.service-card:hover {
  transform: none;
  box-shadow: none;
}

.service-icon {
  margin-bottom: 20px;
  text-align: left;
}

.service-icon img {
  width: 60px;
  height: 60px;
}

.service-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.service-description {
  color: #212121;
  line-height: 1.8;
  margin-bottom: 25px;
  font-size: 16px;
}

.service-more {
  color: #ff6b00;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  font-size: 16px;
  text-decoration: none;
}

.service-more:hover {
  text-decoration: underline;
}

.service-more img {
  width: 20px;
  height: 12px;
}

/* Products Section */
.products {
  padding: 80px 0;
  background-color: #fff;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.product-card {
  padding: 25px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: transform 0.3s, box-shadow 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.product-image {
  text-align: center;
  margin-bottom: 20px;
}

.product-image img {
  width: 120px;
  height: 120px;
}

.product-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.product-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: center;
}

.product-more {
  color: #ff6b00;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-decoration: none;
}

.product-more:hover {
  text-decoration: underline;
}

.product-more img {
  width: 12px;
  height: 12px;
}

.products-more {
  text-align: center;
}

.products-button {
  background-color: transparent;
  color: #ff6b00;
  border: 2px solid #ff6b00;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
}

.products-button:hover {
  background-color: #ff6b00;
  color: #fff;
}

/* News Section */
.news {
  padding: 80px 0;
  background-color: #fff;
}

.news-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-top: 40px;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.news-right {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-tabs {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
}

.news-tab {
  background-color: transparent;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.news-tab.active {
  background-color: #ff6b00;
  color: white;
}

.news-tab:hover {
  background-color: rgba(255, 107, 0, 0.1);
  color: #ff6b00;
}

.news-more {
  margin-left: auto;
  color: #ff6b00;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.news-more:hover {
  text-decoration: underline;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-item {
  padding: 0;
  background-color: transparent;
  border: none;
  box-shadow: none;
  transition: none;
}

.news-item:hover {
  transform: none;
  box-shadow: none;
}

.news-item-content {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.news-item-bullet {
  color: #ff6b00;
  font-size: 16px;
  line-height: 1.6;
  margin-top: 2px;
}

.news-item-title {
  flex: 1;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
  color: #333;
  line-height: 1.6;
  text-decoration: none;
}

.news-item-title:hover {
  color: #ff6b00;
}

.news-item-date {
  color: #999;
  font-size: 14px;
  margin: 0;
  white-space: nowrap;
}

/* Contact Section */
.contact {
  padding: 80px 0;
background: linear-gradient(91deg, #F86B21 0%, #FFB463 99%);
  color: white;
  text-align: center;
}

.contact-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  color: white;
}

.contact-subtitle {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 40px;
  color: white;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.contact-button-container {
  text-align: center;
}

.contact-button {
  background-color: white;
  color: #ff6b00;
  border: none;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
}

.contact-button:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
}
.section-subtitle{
  
  font-family: Source Han Sans;
  font-size: 20px;
  font-weight: normal;
  line-height: 172%;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* bg */
  /* 样式描述：主要使用的背景颜色 */
  color: #212121;
}

/* Breadcrumb Section */
.breadcrumb-section {
  padding: 20px 0;
  background-color: #f8f8fa;
  border-bottom: 1px solid #e0e0e0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-item:hover {
  color: #ff6b00;
}

.breadcrumb-item.active {
  color: #ff6b00;
}

.breadcrumb-separator {
  margin: 0 10px;
  color: #999;
}
</style>